import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button } from "react-bulma-components";
import { connect, useDispatch, useSelector } from "react-redux";
import { doUploadFile } from "./../../../actions/file-upload";

import { head } from "ramda";
import FileUploader from "../../../common/file-uploader/FileUploader";
import StarshopApi from "../../../api/starshop.api";
import { doSetNewImageData } from "../../../actions/starshop";

const StarshopCreateMerchModal = ({ onClose, onConfirm }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [stockAvailable, setStockAvailable] = useState("");
  const [cost, setCost] = useState("");
  const [isHidden, setIsHidden] = useState(false);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const imageDetails = useSelector((state) => state.starshop.newImageData);

  const validateFields = () => {
    const newErrors = {};

    if (!name.trim()) newErrors.name = "Name is required.";
    if (!imageDetails) newErrors.image = "An image must be uploaded.";
    if (!stockAvailable || isNaN(stockAvailable) || parseInt(stockAvailable) < 0)
      newErrors.stockAvailable = "Stock must be a non-negative number.";
    if (!cost || isNaN(cost) || parseInt(cost) < 0)
      newErrors.cost = "Cost must be a non-negative number.";

    const tagRegex = /<\/?[^>]+(>|$)/g;
    if (description && tagRegex.test(description))
      newErrors.description = "Description cannot contain HTML tags.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = () => {
    if (!validateFields()) return;

    onConfirm({
      name,
      description: description.trim(),
      stockAvailable: parseInt(stockAvailable),
      cost: parseInt(cost),
      hidden: isHidden,
      imageFileNames: [{ id: imageDetails.id, type: imageDetails.type }],
    });
  };

  const uploadCallback = useCallback(
    (upLoadData) => {
      const data = head(upLoadData);

      dispatch(
        doUploadFile({
          actions: {
            successAction: doSetNewImageData,
          },
          data: {
            data: data.data,
            type: data.type,
            fileName: data.fileName,
          },
          endPoint: StarshopApi.postAdminUploadImage,
        })
      );
    },
    [dispatch]
  );

  return (
    <Modal.Card>
      <Modal.Card.Head showClose={false}>
        <Modal.Card.Title>Create Merch</Modal.Card.Title>
      </Modal.Card.Head>
      <Modal.Card.Body>
        <Form.Field>
          <Form.Label>Name:</Form.Label>
          <Form.Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Cool mug"
            className={errors.name ? "is-danger" : ""}
          />
          {errors.name && <p className="error-text">{errors.name}</p>}
        </Form.Field>

        <Form.Field>
          <Form.Label>Description:</Form.Label>
          <Form.Textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="You might want to give these to your friends..."
            className={errors.description ? "is-danger" : ""}
          />
          {errors.description && <p className="error-text">{errors.description}</p>}
        </Form.Field>

        <Form.Field>
          <Form.Label>Image:</Form.Label>
          {imageDetails && (
            <img
              className="is-centered"
              src={imageDetails.imageLinks.large}
              alt={imageDetails.id}
            />
          )}
          <FileUploader onUpload={uploadCallback} />
          {errors.image && <p className="error-text">{errors.image}</p>}
        </Form.Field>

        <Form.Field>
          <Form.Label>Stock available:</Form.Label>
          <Form.Input
            type="number"
            value={stockAvailable}
            onChange={(e) => setStockAvailable(e.target.value)}
            className={errors.stockAvailable ? "is-danger" : ""}
          />
          {errors.stockAvailable && <p className="error-text">{errors.stockAvailable}</p>}
        </Form.Field>

        <Form.Field>
          <Form.Label>Cost:</Form.Label>
          <Form.Input
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            className={errors.cost ? "is-danger" : ""}
          />
          {errors.cost && <p className="error-text">{errors.cost}</p>}
        </Form.Field>

        <Form.Field>
          <Form.Control>
            <Form.Checkbox
              checked={isHidden}
              onChange={(e) => setIsHidden(e.target.checked)}
            >
              <strong style={{ marginLeft: '8px' }}>Hidden</strong>
            </Form.Checkbox>
          </Form.Control>
        </Form.Field>

        <Form.Label>Are you sure?</Form.Label>
        <Form.Field kind="group">
          <Form.Control>
            <Button color="success" onClick={handleCreate} disabled={Object.keys(errors).length > 0}>
              Create
            </Button>
          </Form.Control>
          <Form.Control>
            <Button color="" colorVariant="light" onClick={onClose}>
              Cancel
            </Button>
          </Form.Control>
        </Form.Field>
      </Modal.Card.Body>
    </Modal.Card>
  );
};

StarshopCreateMerchModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(StarshopCreateMerchModal);
